import React, { useMemo } from "react"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import TableContainer from "components/Common/TableContainer"
import { Category } from "./types"
import CategoryActionMenu from "./Components/CategoryActionMenu"
import { useTranslation } from "react-i18next"

interface CategoriesTableProps {
  categories: Category[]
  isAllChecked: boolean
  checkedCategories: Category[]
  toggleAllCategories: () => void
  togglecheckedCategoryHandler: (category: Category) => void
  toogleActiveCategory: (category: Category) => void
  deleteCategoryHandler: (category: Category) => void
  editCategoryHandler: (id: string) => void
  viewDetailsHandler: (id: string) => void
  addOfferHandler: (category: Category) => void
  addCompaign: (category: Category) => void
  location?: any
}

const CategoriesTable: React.FC<CategoriesTableProps> = ({
  categories,
  isAllChecked,
  checkedCategories,
  toggleAllCategories,
  viewDetailsHandler,
  togglecheckedCategoryHandler,
  deleteCategoryHandler,
  editCategoryHandler,
  addOfferHandler,
  addCompaign,
  toogleActiveCategory,
  location,
}) => {
  const { t } = useTranslation()

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <input
            type="checkbox"
            className="form-check-input"
            onChange={toggleAllCategories}
            checked={isAllChecked}
          />
        ),
        accessor: "id",
        Cell: (cellProps: { row: { original: Category } }) => {
          return (
            <input
              onClick={e => {
                e.stopPropagation()
                togglecheckedCategoryHandler(cellProps.row.original)
              }}
              checked={Boolean(
                checkedCategories.find(o => o.id === cellProps.row.original.id)
              )}
              type="checkbox"
              className="form-check-input"
            />
          )
        },
      },
      {
        Header: t("categories_categoryName"),
        accessor: "categoryName",
        filterable: true,
        Cell: (cellProps: { row: { original: Category } }) => {
          return <>{cellProps.row.original.categoryName}</>
        },
      },
      {
        Header: t("categories_productCount"),
        accessor: "productCount",
        filterable: true,
        Cell: (cellProps: { row: { original: Category } }) => {
          return <>{cellProps.row.original.productCount}</>
        },
      },
      {
        Header: t("categories_description"),
        accessor: "description",
        filterable: true,
        Cell: (cellProps: { row: { original: Category } }) => {
          return <>{cellProps.row.original.description}</>
        },
      },
      {
        Header: t("categories_tags"),
        accessor: "tags",
        filterable: true,
        Cell: (cellProps: { row: { original: Category } }) => {
          return (
            <div className="d-flex flex-wrap">
              {cellProps.row.original.tags.map((tag, index) => (
                <span
                  key={index}
                  className="badge bg-primary-30 text-primary fw-semibold me-1 px-2 py-1 font-size-10"
                >
                  {tag}
                </span>
              ))}
            </div>
          )
        },
      },
      {
        Header: t("categories_status"),
        accessor: "status",
        filterable: true,
        Cell: (cellProps: { row: { original: Category } }) => {
          return (
            <div className="form-check form-switch mb-3">
              <input
                type="checkbox"
                className="form-check-input"
                id={`customSwitch${cellProps.row.original.id}`}
                checked={cellProps.row.original.status === "Active"}
                onChange={e => {
                  e.stopPropagation()
                }}
                onClick={e => {
                  e.stopPropagation()
                  toogleActiveCategory(cellProps.row.original)
                }}
              />
              <label
                className="form-check-label text-capitalize"
                htmlFor={`customSwitch${cellProps.row.original.id}`}
              >
                {cellProps.row.original.status}
              </label>
            </div>
          )
        },
      },
      {
        Header: " ",
        Cell: (cellProps: { row: { original: Category } }) => {
          const order = cellProps.row.original
          return (
            <CategoryActionMenu
              category={order}
              editCategoryHandler={editCategoryHandler}
              viewDetailsHandler={viewDetailsHandler}
              deleteCouponHandler={deleteCategoryHandler}
              addOfferHandler={addOfferHandler}
              addCompaign={addCompaign}
            />
          )
        },
      },
    ],
    [categories, t, checkedCategories]
  )

  return (
    <TableContainer
      columns={columns}
      data={categories}
      isGlobalFilter={true}
      isAddOptions={false}
      customPageSize={5}
      isJobListGlobalFilter={undefined}
      isAddUserList={undefined}
      handleOrderClicks={undefined}
      handleUserClick={undefined}
      handleCustomerClick={undefined}
      isAddCustList={undefined}
      className={undefined}
      customPageSizeOptions={undefined}
    />
  )
}

CategoriesTable.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(CategoriesTable))
